import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const PAGES_API = "https://fetc.in/api/v1/pages";

export const pageApi = createApi({
  reducerPath: "pagesApi",
  tagTypes: ["Pages"],
  baseQuery: fetchBaseQuery({ baseUrl: PAGES_API, credentials: "include" }),
  endpoints: (builder) => ({
    createPage: builder.mutation({
      query: (formData) => ({
        url: "/create",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["Pages"],
    }),

    getPages: builder.query({
      query: () => "/list",
      providesTags: ["Pages"],
    }),

    getPublishedPages: builder.query({
      query: () => "/published",
      providesTags: ["Pages"],
    }),

    getCreatorPages: builder.query({
      query: () => "/user",
      providesTags: ["Pages"],
    }),

    getPageBySlug: builder.query({
      query: (slug) => `/${slug}`,
      providesTags: (result, error, slug) => [{ type: "Pages", id: slug }],
    }),

    editPage: builder.mutation({
      query: ({ slug, formData }) => ({
        url: `/${slug}`, // Make sure this matches your route
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: (result, error, { slug }) => [
        { type: "Pages", id: slug }, // remove old slug cache
        "Pages", // refresh full list
        ...(result?.page?.slug && result.page.slug !== slug
          ? [{ type: "Pages", id: result.page.slug }]
          : []), // update cache with new slug
      ],
    }),
    

    deletePage: builder.mutation({
      query: (slug) => ({
        url: `/${slug}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Pages"],
    }),
  }),
});

export const {
  useCreatePageMutation,
  useGetPagesQuery,
  useGetPublishedPagesQuery,
  useGetCreatorPagesQuery,
  useGetPageBySlugQuery,
  useEditPageMutation,
  useDeletePageMutation,
} = pageApi;
